var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.8667 14 14 10.8667 14 7C14 3.13333 10.8667 -2.73925e-07 7 -6.11959e-07C3.13333 -9.49994e-07 9.49994e-07 3.13333 6.11959e-07 7C2.73925e-07 10.8667 3.13333 14 7 14ZM7 1.11111C10.2444 1.11111 12.8889 3.75556 12.8889 7C12.8889 10.2444 10.2444 12.8889 7 12.8889C3.75556 12.8889 1.11111 10.2444 1.11111 7C1.11111 3.75555 3.75556 1.11111 7 1.11111Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77741 7.55554L10.1107 7.55555L7.51074 10.1555C7.28852 10.3778 7.28852 10.7333 7.51074 10.9333C7.73296 11.1333 8.08852 11.1555 8.28852 10.9333L11.8441 7.37777C12.0663 7.15555 12.0663 6.79999 11.8441 6.59999L8.28852 3.04443C8.17741 2.93332 8.04408 2.88888 7.88852 2.88888C7.73297 2.88888 7.59963 2.95555 7.48852 3.04443C7.37741 3.13332 7.33297 3.28888 7.33297 3.44443C7.33297 3.59999 7.39963 3.73332 7.48852 3.84443L10.1107 6.44443L2.77741 6.44443C2.4663 6.44443 2.22185 6.68888 2.22185 6.99999C2.22185 7.3111 2.4663 7.55554 2.77741 7.55554Z",
    fill: "#A8A8A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 14,
    height: 14,
    transform: "rotate(-180 14 14)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.1b3c621d8624635d43e065fe574b6160.svg";
export { ForwardRef as ReactComponent };